import { connect } from 'react-redux';
import GlobalStyling from './GlobalStyling';

export default connect(state => ({
  isModalOpen: state.view ? state.view.components.modal.isOpen : false,
  scrollbarWidth: state.deviceState ? state.deviceState.scrollbarWidth : false,
}))(GlobalStyling);
